import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary" }, "Terminkalender")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseFilter = _resolveComponent("CourseFilter")!
  const _component_AppointmentsCalendar = _resolveComponent("AppointmentsCalendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_CourseFilter, {
      locations: _ctx.filterLocations,
      "course-types": _ctx.filterCourseTypes,
      class: "pb-md-2 mb-4"
    }, null, 8, ["locations", "course-types"]),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_AppointmentsCalendar, {
          key: 0,
          appointments: _ctx.appointments
        }, null, 8, ["appointments"]))
      : _createCommentVNode("", true)
  ], 64))
}